import * as sharedTypes from 'src/actions/shared/sharedTypes';
import analytics from '@ad-scripts/lib/analytics';

const logout: sharedTypes.AppThunk =
  () =>
  async (dispatch, getState, { stores, backend }) => {
    const state: any = getState();
    const userId = state.auth.userId;
    const axios = backend.axios();
    try {
      await axios.delete(`/api/v3/desktop_tokens/${userId}`);
    } catch (e) {
      // it is ok
    }

    analytics.track('Admin User Logout', {
      roleIds: state.auth.roleIds,
      isImitatedAgent: !!state.auth.saganUser,
    });

    stores.auth.remove();
    analytics.disableDefault();
    window.location.replace('/user/logout');
  };
export default logout;
